import frustumCull from '../frustumCull'
import noise3D from '../noise3D'

export default `${noise3D}
uniform vec4 uRectData;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uBgColor;
uniform vec4 uProgress;
uniform vec3 uLightPos;
uniform vec3 uRandom;
uniform mat3 normalMatrix;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;

float random(vec3 st){
  return fract(sin(dot(st.xyz,vec3(12.9898,78.233, 45.164)))*43758.5453123);
}

void main(){


  vec3 no = abs(vNormal);
  // Find which component is largest and create one-hot vector
  float maxComponent = max(no.x, max(no.y, no.z));
  no = vec3(equal(no, vec3(maxComponent)));

  vec3 no2 = normalize(normalMatrix * (no * sign(vNormal)));

  vec3 pos = floor((vPosition) * 4.0 + 0.5);
  float n = noise(pos + no + vec3(0.5, 1.0, 0.5) * -uProgress.z * 2.0);
  float light = dot(normalize(no2), uLightPos) * 0.5 + 0.5;
  // distance from light
  float light2 = length(normalize(normalMatrix * vPosition) - uLightPos * 2.0);
  light2 = smoothstep(4.0, 0.0, light2);

  n = step(0.5, n);

  vec3 color1 = mix(uColor1 - 0.2, uColor1, light);
  vec3 color2 = mix(uColor2 - 0.7, uColor2, light);
  color2 += mix(-0.2, 0.1, light2);
  vec3 color = mix(color1, color2, n);

  #ifndef IS_GLASS_RENDER
  ${frustumCull}
  #endif

  color = mix(uBgColor, color, uProgress.x );

  gl_FragColor = vec4(color, 1.0);

  gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.0/2.2));

}
`
